import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { User } from '../interfaces/user';
import { AuthenticationService } from '../services/authentication.service';
import { UserService } from '../services/user.service';

@Component({
  selector: 'app-utilities',
  templateUrl: './utilities.component.html',
  styleUrls: ['./utilities.component.css']
})
export class UtilitiesComponent implements OnInit {
  @Input() pageTitle: string;
  user: User;

  constructor(
    private router: Router, 
    private authService: AuthenticationService, 
    private userService: UserService) {}

  ngOnInit() {
    this.authService.getStatus().subscribe(
      (user) => {
        if (user != null) {
          this.userService.getUserById(user.uid).valueChanges().subscribe(
          (data: User) => {
            this.user = data;
          }, (error) => {
            console.log(error);
          });
        }
      });
  }
  logout(uid) {
    this.authService.logout().then(
        () => {
          const active = {
            uid: uid,
            value: 0
          }
          this.userService.setActive(active).then(
            () => {
              this.router.navigate(['login']);
          }).catch(
            (error) => { console.log(error); 
          });
        }).catch(
        (error) => {
          console.log(error);
        });
  }
}
